import Vue        	   from 'vue'
import App        	   from './App'
import VueRouter 		   from 'vue-router'
import Routes 			   from './shared/routes'
import { store }		   from './shared/store/main';
import axios 				   from 'axios';
import mixins  			   from "./shared/mixins"
import NProgress 		   from 'nprogress';
import VueAnalytics    from 'vue-analytics'
import Tooltip 			   from 'vue-directive-tooltip';
import VueScrollTo     from 'vue-scrollto';
import VModal          from 'vue-js-modal';
import highlight       from 'vue-highlight-text/public/directive.min';
import Autocomplete    from 'v-autocomplete'
import jwtDecode       from 'jwt-decode';
import moment          from 'moment';
import Meta            from 'vue-meta'
import VuePikaday      from '@enrian/vue-pikaday'
import VueClipboard    from 'vue-clipboard2'

import 'vue-directive-tooltip/css/index.css'
import 'nprogress/nprogress.css'
import './assets/css/main.css'
import 'v-autocomplete/dist/v-autocomplete.css'
import '@enrian/vue-pikaday/dist/vue-pikaday.min.css'


import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

Vue.config.productionTip = false
Vue.mixin(mixins)
Vue.use(VueRouter)
Vue.use(Tooltip)
Vue.use(VueScrollTo)
Vue.use(VModal, { dialog : true})
Vue.directive('highlight', highlight)
Vue.use(Autocomplete)
Vue.use(Meta)
Vue.use(VuePikaday)
Vue.use(VueClipboard)

// create a global bus event
// Vue.prototype.$bus = new Vue();

// create a router object and instantiate it
const router = new VueRouter({
  mode  : process.env.NODE_ENV == 'production' ? 'history' : 'hash',
  routes: Routes,

  // below is to make sure when we land on the new route, window
  // by default scrolls to the top of the page
	scrollBehavior (to, from, savedPosition) {
		return { x: 0, y: 0 }
	}
})

// google analytics only in prod
if(process.env.NODE_ENV == 'production') {
	Vue.use(VueAnalytics, {
	  id : 'UA-38040251-24',
	  router,
	  autoTracking: {
			exception    : true,
			exceptionLogs: false
	  }
	})
}

router.beforeEach((to, from, next) => {

	NProgress.configure({ showSpinner: false })
	NProgress.start()
  // document.body.className = to.path.indexOf('auth/') > -1 || to.path.indexOf('/logged-out') > -1 ? 'blue-bg' : '';

	// check if token is expired here
	if(localStorage.getItem('bp-broker-jwt')) {
    // console.log(localStorage.getItem('dub-jwt'))
    let jwt = jwtDecode(localStorage.getItem('bp-broker-jwt'))
    // console.log(moment.unix(jwt.exp).format("dddd, MMMM Do YYYY, h:mm:ss a"))
    // console.log(moment.unix(jwt.iat).format("dddd, MMMM Do YYYY, h:mm:ss a"))

    // when was the last time we checked for validation of token?
    let lastValidation = localStorage.getItem('bp-broker-jwt-last-validation')
    let currentTime    = moment().unix()

    if(lastValidation == null || currentTime - lastValidation > 180) {

      axios.get(process.env.VUE_APP_API_URL + '/api/auth/validate-token', {
        headers: {
          'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
        }
      }).then(res => {
        
        // received a new token
        if(parseInt(res.data) != 1) {
          localStorage.setItem("bp-broker-jwt", res.data)
        }

        localStorage.setItem('bp-broker-jwt-last-validation', moment().unix())
        store.commit('setIsLoggedIn', true)
        next()
      }).catch( (e) => {

        // not logged in
        store.commit('setIsLoggedIn',   false)

        // does the route require auth?
        if(to.meta && to.meta.auth == true) {

          if(to.meta.loginMessage != null) {
            store.commit('setLoginMessage', to.meta.loginMessage)
          }

          store.commit('setRedirectUrl',  to.path)
          next({
            path : '/auth/login', 
          })  
        }
        else {
          next()
        }
      })
    }
    else {
      next()
    }
  }

  else {

  	// not logged in
  	store.commit('setIsLoggedIn', 	false)

  	// does the route require auth?
  	if(to.meta && to.meta.auth == true) {
    	store.commit('setLoginMessage', to.meta.loginMessage)
			store.commit('setRedirectUrl', 	to.path)
			NProgress.done()
			next({
				path : '/auth/login',
			})
  	}

  	else {
  		next()
  	}
  }
})

router.afterEach((to, from) => {
  NProgress.done()
})

new Vue({

  // below properties are injected to view
  // so we can access them throughout the app
  router  : router,
  store   : store,

  el      : '#app',
  render  : h => h(App),
})
